

































































































import XLSX from 'xlsx';
import { Component, Mixins, Vue, Watch } from 'vue-property-decorator';
import { EventBus, hasElements, TypeEventBus, sortObjectByPropertyName, formatComplexList, formatCommaSeparatedStringList } from '../../core/utils';
import { CompanyStoreHelper, NotificationStoreHelper, RootStoreHelper, AuthStoreHelper } from '../../core/mixins';
import { FilterDateEvent } from '../../core/utils/types';
import { TypeFilterDate } from '../../core/models/type-filter-date';
import Axios from 'axios';
import VariableClassification from '../components/VariableClassification.vue';
import { NAME_ROUTES } from '../../core/utils/name-routes';
import { NormsServices } from '../api/NormsServices';
import { PageTitle } from '../../core/components';
import DeleteConfirmation from '../../tracking/components/Geofences/DeleteConfirmation.vue';
import { PRIVILEGE_KEYS, PRIVILEGE_TYPES } from '../../core/utils/privileges';
import Input from '../../core/components/Input.vue'; 
import SimpleTable from '../../core/components/SimpleTable.vue'; 
@Component({
    components: {
        PageTitle,
        VariableClassification,
        DeleteConfirmation,
        Input,
        SimpleTable
    }
})
export default class NormasVariableClassificationList extends Mixins(
    CompanyStoreHelper,
    NotificationStoreHelper,
    RootStoreHelper,
    AuthStoreHelper
) {
    confirmationDelete: boolean = false;
    deleteModalTitle: string = '';
    deleteBody: string = '';
    deleteMsg: string = '';
    variableClassificationToDelete: number = -1;
    selectedItemForDeletion: any = {};

    submitedData: any = {};

    pendingRequestLoadingDialog: boolean = false;
    successPost: boolean | null = null;
    loadingMsg: string = '';
    errorLoadMsg: object = {};

    //create frame props
    visibleModalCreateFrame: boolean = false;
    framesTypes: any = [];
    frameToPatch: any = {};
    currentAction: string = '';
    categoriesOptions: any = [];
    editingFrame: boolean = false;

    deleteConfirmationTitle: string = 'Eliminar Variable classification';
    deleteConfirmationMessage: string =
        '¿Está seguro que desea eliminar esta Variable classification? Ésta acción no se podrá deshacer.';

    loadingPreviewData: boolean = false;
    previewFrame: object = {};
    showModalCreateEcu: boolean = false;
    frameToDelete: number | null = null;
    pendingRequest: boolean = false;
    showDeleteConfirmationDialog: boolean = false;
    search: string = '';
    pendingProtocols: boolean = false;
    protocolSelected: any = null;
    protocolOptions: any = [];

    get getHeaders() {
        if (this.shouldCreateEditVariableClassification) {
            return this.headers;
        } else {
            return this.headers.filter(function(header) {
                return header.value !== 'actions';
            });
        }
    }

    get shouldCreateEditVariableClassification(): boolean {
        return this.$_checkPrivileges(PRIVILEGE_KEYS.NORMS, PRIVILEGE_TYPES.EDIT_AND_DELETE) || this.$_userIsSmartway;
    }

    get shouldCreateVariableClassification(): boolean {
        return this.$_checkPrivileges(PRIVILEGE_KEYS.NORMS, PRIVILEGE_TYPES.CREATE) || this.$_userIsSmartway;
    }

    headers: any[] = [
        {
            text: 'Descripción',
            align: 'left',
            value: 'description',
            tooltip: ''
        },
        {
            text: 'Unidad',
            align: 'left',
            value: 'unit.description',
            tooltip: ''
        },
        {
            text: 'Alarmable',
            align: 'center',
            value: 'alarmable',
            tooltip: ''
        },
        {
            text: 'Activa en grupos de variables',
            align: 'left',
            value: 'in_variable_groups',
            formatter: this.parseList,
            tooltip: ''
        },
        {
            text: 'Acciones',
            align: 'left',
            value: 'actions',
            sortable: false,
            tooltip: '',
            width: '80px'
        }
    ];
    items: any = [];
    pagination: object = {
        rowsPerPageItems: 18
    };
    protocolTypes: any = [];
    pendingRequestPatchFrame: boolean = false;

    editing: boolean = false;
    variableGroupToEdit: any = null;
    variablesDefinitionFromSelectedVariableClassification: any[] | null = null;
    show: boolean = false;

    parseList(list: string[]){
        return formatCommaSeparatedStringList(list)
    }

    getVariableClassificationData(submitedData) {
        this.submitedData = submitedData;
    }

    selectedVariableClassification: any = {};

    async getVariableClassificationById(id) {
        this.selectedVariableClassification = await NormsServices.getVariableClassificationById(id);
        this.variablesDefinitionFromSelectedVariableClassification = this.selectedVariableClassification.variable_definitions;
    }

    pendingLoadingDialog(msg){
        this.$_showLoadingDialog(msg);
    }
    handleSuccessAction(response){
        this.$_successLoadingDialog({
            response: response
        });
    }
    handleErrorAction(error, alternative_msg){
        this.$_catchLoadingDialog({
            response: error.response.data || {},
            alternative_msg: alternative_msg
        });
    }

    postVariableClassification() {
        this.pendingLoadingDialog('Creando variable definition...')
        let variableDefinition: any = {
            description: this.submitedData.description,
            unit: this.submitedData.unit,
            alarmable: this.submitedData.alarmable
        };
        NormsServices.postCreateVarClassification(variableDefinition)
            .then(response => {
                this.handleSuccessAction(response);
                setTimeout(() => {
                    this.closeAddOrEditVariableGroup();
                }, 1200);
                this.getVariableClassificationList();
            })
            .catch(error => {
                this.handleErrorAction(error, 'No se pudo crear la variable classification')
            });
    }

    async patchVariableClassification() {
        this.pendingLoadingDialog('Modificando variable definition...')
        let variableClassification: any = {
            description: this.submitedData.description,
            unit: this.submitedData.unit,
            alarmable: this.submitedData.alarmable,
            variable_definition_list: this.submitedData.variable_definition_list.map(variable => variable.id)
        };
        NormsServices.patchVariableClassification(variableClassification, this.variableGroupToEdit.id)
            .then(response => {
                this.handleSuccessAction(response.data);
                this.$_successPatchRecipients(response.data.message);
                setTimeout(() => {
                    this.closeAddOrEditVariableGroup();
                }, 1200);
                this.getVariableClassificationList();
            })
            .catch(error => {
                this.handleErrorAction(error, 'No se pudo modificar la variable classification')
            });
    }

    deleteVariableClassificationAction() {
        this.pendingRequest = true;
        if (this.variableClassificationToDelete !== -1) {
            NormsServices.deleteVariableClassification(this.selectedItemForDeletion.id)
                .then(response => {
                    this.$_successPatchRecipients(response.data.message);
                    this.pendingRequest = false;

                    //borra la variable classification del listado
                    this.items = this.items.filter(variable => {
                        return this.selectedItemForDeletion != variable;
                    });
                })
                .catch(error => {
                    this.$_errorAddPointOfInterest(error);
                    this.pendingRequest = false;
                });
        }
    }

    deleteVariableClassification(item) {
        this.selectedItemForDeletion = item;
        this.variableClassificationToDelete = Number(item['id']);
        if (item.in_variable_groups.length > 0) {
            this.deleteModalTitle = 'Eliminar variable classification';
            this.deleteBody =
                '¿Está seguro que desea eliminar la variable classification ' + '<b>"' + item['description'] + '"</b>?';
            this.deleteMsg =
                'Esta clasificación esta presente en los grupos: ' +
                '<b>"' +
                item.in_variable_groups.join(', ') +
                '"</b>. Se desconfigurara esta variable asociada a los vehiculos que tengan estos grupos activados';
            this.confirmationDelete = true;
        } else {
            this.showDeleteConfirmationDialog = true;
        }
    }

    deleteAction(value) {
        if (value) {
            this.confirmationDelete = false;
            this.showDeleteConfirmationDialog = false;
            this.pendingRequest = true;
            this.deleteVariableClassificationAction();
        } else {
            this.showDeleteConfirmationDialog = false;
            this.confirmationDelete = false;
            this.variableClassificationToDelete = -1;
        }
    }

    resetLoadingDialog() {
        this.successPost = null;
        this.pendingRequestLoadingDialog = false;
        this.loadingMsg = '';
    }

    showLoadingDialog(msg) {
        this.pendingRequestLoadingDialog = true;
        this.successPost = null;
        this.loadingMsg = msg;
    }

    closeLoadingModal() {
        this.pendingRequest = false;
        this.successPost = null;
        this.loadingMsg = '';
    }

    showSuccessLoadingDialog(msg) {
        this.successPost = true;
        this.loadingMsg = msg;
        setTimeout(() => {
            this.resetLoadingDialog();
        }, 1000);
    }

    showErrorLoadingDialog(error) {
        this.successPost = false;
        this.errorLoadMsg = {};
        if (error && error.response && error.response.data && error.response.data.message) {
            this.loadingMsg = 'Ocurrió un error';
            this.errorLoadMsg = error.response.data.message;
        } else {
            this.loadingMsg = 'Alerta';
            this.errorLoadMsg = error.message;
        }
    }

    closeAddOrEditVariableGroup() {
        this.show = false;
    }

    createVariableClassification() {
        this.editing = false;
        this.variableGroupToEdit = null;
        this.show = true;
    }

    async editVariableClassification(item) {
        this.variableGroupToEdit = item;
        await this.getVariableClassificationById(this.variableGroupToEdit.id);
        this.editing = true;
        this.show = true;
    }

    close() {
        this.show = false;
        this.editing = false;
    }

    // variableGroupDialog(value) {
    //     this.show = value;
    // }

    getVariableClassificationList() {
        this.pendingRequest = true;
        NormsServices.getVariableClassificationList()
            .then(response => {
                this.items = response;
                this.pendingRequest = false;
            })
            .catch(error => {
                this.pendingRequest = false;
            });
    }

    backToNormas() {
        this.$router.push(NAME_ROUTES.NORMAS.path);
    }

    mounted() {
        this.getVariableClassificationList();
    }

    updateSearchValue(value){
        this.search = value;
    }
}
